const moduleName = 'globalError';

export const getGlobalError = state => state[moduleName];

export const getGlobalErrorCode = state => state[moduleName].code;
